/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zero_DragInputs */

const en_zero_drag = /** @type {(inputs: Zero_DragInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zero Drag.`)
};

const es_zero_drag = /** @type {(inputs: Zero_DragInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cero fricción.`)
};

const fr_zero_drag = /** @type {(inputs: Zero_DragInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zéro friction.`)
};

const de_zero_drag = /** @type {(inputs: Zero_DragInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Null Reibungsverlust.`)
};

const ja_zero_drag = /** @type {(inputs: Zero_DragInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`摩擦ゼロ。`)
};

const zh_zero_drag = /** @type {(inputs: Zero_DragInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`零摩擦。`)
};

const ar_zero_drag = /** @type {(inputs: Zero_DragInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انعدام العوائق.`)
};

const id_zero_drag = /** @type {(inputs: Zero_DragInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nol Hambatan.`)
};

const it_zero_drag = /** @type {(inputs: Zero_DragInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zero Attriti.`)
};

const ru_zero_drag = /** @type {(inputs: Zero_DragInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нулевым сопротивлением.`)
};

const pt_zero_drag = /** @type {(inputs: Zero_DragInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atrito Zero.`)
};

const ko_zero_drag = /** @type {(inputs: Zero_DragInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`마찰 제로.`)
};

/**
* | output |
* | --- |
* | "Zero Drag." |
*
* @param {Zero_DragInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const zero_drag = /** @type {((inputs?: Zero_DragInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zero_DragInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_zero_drag(inputs)
	if (locale === "es") return es_zero_drag(inputs)
	if (locale === "fr") return fr_zero_drag(inputs)
	if (locale === "de") return de_zero_drag(inputs)
	if (locale === "ja") return ja_zero_drag(inputs)
	if (locale === "zh") return zh_zero_drag(inputs)
	if (locale === "ar") return ar_zero_drag(inputs)
	if (locale === "id") return id_zero_drag(inputs)
	if (locale === "it") return it_zero_drag(inputs)
	if (locale === "ru") return ru_zero_drag(inputs)
	if (locale === "pt") return pt_zero_drag(inputs)
	return ko_zero_drag(inputs)
});